// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockListSubtitle_wrapper__18T13","test":"BlockListSubtitle_test__3Y4-q","subtitle":"BlockListSubtitle_subtitle__1AjDE","desc":"BlockListSubtitle_desc__1TsRe"};